// extracted by mini-css-extract-plugin
export default {"container":"PaymentMethod_container__umfn-","image":"PaymentMethod_image__zEYKB","title":"PaymentMethod_title__ks6Ev","btnWrapper":"PaymentMethod_btnWrapper__RXvkW"};